<template>
  <div>
    <div>
      <div class="backdrop">
        <div class="container flex-row  justify-center align-center">
          <div class="form ">
            <el-form ref="form" :rules="rules" :model="form" label-width="0px" size="mini">
              <el-form-item>
                <div class="form-title-one">
                  登录
                </div>
              </el-form-item>
              <el-form-item prop="user">
                <el-input placeholder="请输入账号" v-model="form.user"></el-input></el-form-item>
              <el-form-item prop="password">
                <el-input placeholder="请输入密码" show-password v-model="form.password"></el-input></el-form-item>
              <el-form-item>
                <el-button style="margin-top:30px" @click="onSubmit">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
export default {
  name: "freeTrial",
  data() {
    return {
      form: {
        user: "",
        password: "",
      },
      rules: {
        user: [
          { required: true, message: "请输入账号", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          request({
            url: 'api/Account',
            method: 'post',
            data: {
              "username": this.form.user,
              "pwd": this.form.password
            }
          }).then((res) => {
            if (res.data.success) {
              this.$store.commit('loginSuccess', true)
              this.$store.commit('setToken', res.data.data)
              sessionStorage.setItem('token',res.data.data)
              sessionStorage.setItem('isToken',true)
              this.$router.replace('/tables')
            } else {
              this.$message.error(res.data.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.backdrop {
  background: #d3e8fe;
  padding-top: 80px;
  backdrop-filter: blur(4px);
  height: 600px;
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.top {
  width: 606px;
  color: #333333;
  line-height: 38px;

  p {
    font-size: 16px;
  }
}

.text1 {
  height: 48px;
  font-size: 36px;
  font-weight: 600;
  color: black;
  line-height: 48px;
  margin-block-end: 0em;
}

.text2 {
  height: 48px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: black;
  line-height: 48px;
}

.text3 {
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
}

.form {
  width: 451px;
  min-height: 360px;
  background: #ffffff;
  box-shadow: 0px 0px 22px 0px #b9cef6;
  border-radius: 8px;

  .form-title-one {
    height: 30px;
    font-size: 18px;
    font-weight: 600;
    color: #2970ec;
    line-height: 25px;
  }

  .form-title-two {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
  }
}

.el-input__inner {
  height: 52px !important;
  line-height: 28px;
}

.el-input::v-deep {
  .el-input__inner {
    height: 52px;
    line-height: 52px;
  }
}

.el-form-item--mini.el-form-item {
  margin-bottom: 20px;
}

.el-form {
  margin: 0 auto;
  margin-top: 40px;
  width: 357px;
  height: 80%;

  p {
    padding-left: 28px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
  }

  .el-button {
    width: 357px;
    height: 52px;
    border-radius: 2px;
  }
}

.dian {
  width: 9px;
  height: 8px;
  background: linear-gradient(270deg, #99baff 0%, #2970ec 100%);
  border-radius: 50px;
  display: inline-block;
}
</style>
